import { useState } from "react";

export default function ShareActions({ title }: { title: string }) {
  const [toast, setToast] = useState("");
  const [wechatOpen, setWechatOpen] = useState(false);

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2000);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="text-sm text-foreground-500">分享这条爆料：</span>

      <button
        type="button"
        onClick={copyLink}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-link" />
        复制链接
      </button>

      <button
        type="button"
        onClick={() => setWechatOpen(true)}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-wechat-line" />
        微信分享
      </button>

      <button
        type="button"
        onClick={() => showToast("已生成微博分享卡片（演示）")}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-weibo-line" />
        分享到微博
      </button>

      {toast && (
        <span className="text-sm text-primary-600 animate-fade-in">{toast}</span>
      )}

      {wechatOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
          onClick={() => setWechatOpen(false)}
        >
          <div
            className="bg-background-50 rounded-lg p-6 w-full max-w-xs text-center animate-fade-up"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-base font-bold text-foreground-950">
              微信扫码分享
            </h3>
            <div className="w-40 h-40 mx-auto my-5 rounded-lg bg-background-100 flex items-center justify-center text-6xl text-foreground-300">
              <i className="ri-qr-code-line" />
            </div>
            <p className="text-sm text-foreground-500 line-clamp-2">
              {title}
            </p>
            <p className="text-xs text-foreground-400 mt-2">
              演示环境暂不支持真实扫码分享
            </p>
            <button
              type="button"
              onClick={() => setWechatOpen(false)}
              className="mt-5 w-full px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-white text-sm transition-colors cursor-pointer"
            >
              关闭
            </button>
          </div>
        </div>
      )}
    </div>
  );
}